import * as Types from '../constants/Types';

export const exportBundleReportExcel = (params) => ({type: Types.EXPORT_BUNDLE_REPORT_EXCEL, params})